<template>
    <!-- Modal de Confirmação -->
    <div v-if="show" class="modal-overlay">
        <div class="modal" tabindex="-1" role="dialog" style="display: block;">
            <div class="modal-dialog" role="document">
                <div class="modal-content p-3">
                    <h5 class="modal-title mb-3 text-start">Registrar Ocorrência</h5>

                    <form @submit.prevent="handleSubmit">
                        <!-- CPF / ROL e Nome lado a lado -->
                        <div class="row mb-3 g-2">
                            <div class="col-12 col-md-6">
                                <label for="cpf_rol" class="form-label text-start">CPF ou ROL</label>
                                <input id="cpf_rol" type="text" class="form-control" style="height: 45px;"
                                    :class="{ 'is-invalid': errors.cpf_rol }" placeholder="CPF ou ROL"
                                    v-model="form.cpf_rol" @blur="getNomeObreiro" />
                                <div class="invalid-feedback" v-if="errors.cpf_rol">
                                    {{ errors.cpf_rol[0] }}
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <label for="nome" class="form-label text-start">Nome do Visitante</label>
                                <input style="height: 45px;" id="nome" type="text" class="form-control"
                                    placeholder="Nome do Visitante" v-model="form.nome" disabled />
                            </div>
                        </div>

                        <!-- Tipo e Data lado a lado -->
                        <div class="row mb-3 g-2">
                            <div class="col-12 col-md-6">
                                <label for="tipo" class="form-label text-start">Tipo de ocorrência</label>
                                <select
                                    id="tipo"
                                    class="form-control"
                                    placeholder="Tipo"
                                    :class="{ 'is-invalid': errors.tipo_ocorrencia }"
                                    style="height: 45px; padding: 0; padding-left: 13px;"
                                    v-model="form.tipo_ocorrencia"
                                >
                                    <option value="106">Visita</option>
                                    <option value="107">Ocorrência</option>
                                </select>

                                <div class="invalid-feedback" v-if="errors.tipo_ocorrencia">
                                    {{ errors.tipo_ocorrencia[0] }}
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <label for="data" class="form-label text-start">Data</label>
                                <input id="data" type="date" class="form-control" style="height: 45px;"
                                    :class="{ 'is-invalid': errors.data_ocorrencia }" v-model="form.data_ocorrencia" />
                                <div class="invalid-feedback" v-if="errors.data_ocorrencia">
                                    {{ errors.data_ocorrencia[0] }}
                                </div>
                            </div>
                        </div>

                        <!-- Observações -->
                        <div class="mb-3">
                            <label for="observacoes" class="form-label text-start">Observações</label>
                            <textarea id="observacoes" class="form-control" rows="3"
                                placeholder="Digite suas observações" v-model="form.observacoes"
                                :class="{ 'is-invalid': errors.observacoes }"></textarea>
                            <div class="invalid-feedback" v-if="errors.observacoes">
                                {{ errors.observacoes[0] }}
                            </div>
                        </div>

                        <!-- Botões -->
                        <div class="d-flex justify-content-end gap-2">
                            <button type="button" class="btn btn-secondary btn-outline-secondary flex-fill"
                                @click="$emit('close')"
                                style="height: 45px; border-radius: 8px; font-weight: bolder; background-color: transparent; border: 1px solid #969EA4; color: #969EA4; margin-bottom: 10px; width: 50%;">
                                Cancelar
                            </button>

                            <button type="submit" class="btn btn-primary flex-fill"
                                style="height: 45px; border-radius: 8px; background-color: rgb(19, 106, 159) !important; font-weight: bolder; border-color: rgb(19, 106, 159) !important; width: 50%;">
                                Salvar
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import colheitaService from "@/services/colheitaService";

export default {
    name: 'ModalRegistroOcorrencia',

    props: {
        show: {
            type: Boolean,
            default: false
        },
        num_ficha: {
            type: String,
            default: ""
        },
        modelValue: {
            type: Object,
            default: () => ({
                num_ficha_decisao: this.num_ficha,
                cpf_rol: '',
                nome: '',
                tipo_ocorrencia: '',
                data_ocorrencia: '',
                observacoes: ''
            })
        }
    },

    data() {
        return {
            form: {
                num_ficha_decisao: this.num_ficha || '',
                ...this.modelValue
            },
            token: this.$root.token || {},
            errors: {}
        }
    },

    watch: {
        modelValue: {
            deep: true,
            handler(novo) {
                this.form = { ...novo }
            }
        }
    },

    methods: {
        async getNomeObreiro() {
            const { nome } = await colheitaService.getNomeObreiro(this.form.cpf_rol, this.token);
            this.form.nome = nome;
        },

        async handleSubmit() {
            this.carregando = true
            this.errors = {} 
            const result = await colheitaService.registrarOcorrencia(this.form, this.token);

            if (!result.success) {
                this.errors = result.errors;
                console.error(result.message);
            } else {
                this.$emit('submit', result.data);
                this.$emit('close');
            }

            this.carregando = false;
        }
    }
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}

label {
    width: 100%;
}

.form-control {
    padding: 13px;
}

.invalid-feedback {
    text-align: left;
}
</style>